if (!customElements.get('personalizacion-caracola')) {
  customElements.define(
    'personalizacion-caracola',
    class PersonalizacionCaracola extends HTMLElement {
      connectedCallback() {
        this.btns = this.querySelectorAll('[data-personalizacion]');
        this.letteringWrap = this.querySelector('.personalizacion__lettering');
        this.letteringInput = this.querySelector('[data-personalizacion-lettering]');
        this.hiddenProp = this.querySelector('[data-personalizacion-hidden]');
        this.optionInput = this.querySelector('[data-personalizacion-option]');
        this.variantNo = this.dataset.variantNo;
        this.variantSi = this.dataset.variantSi;

        this.btns.forEach((btn) => {
          btn.addEventListener('click', () => this.select(btn.dataset.personalizacion));
        });

        // product-form.js escucha el submit en el propio formulario (con
        // novalidate) y se registra antes que este elemento, así que el
        // `required` no frenaba nada. Validamos en la fase de captura del
        // documento, que corre antes, y cortamos el envío si falta algo.
        // Antes se quitaba aquí el `name` del campo vacío y no se devolvía:
        // tras un intento sin nombre, el que se escribía después no llegaba.
        this.onSubmit = this.onSubmit.bind(this);
        document.addEventListener('submit', this.onSubmit, true);

        this.select('no', { silent: true });
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.onSubmit, true);
      }

      onSubmit(evt) {
        // getAttribute: el <input name="id"> de la variante tapa form.id.
        if (!this.dataset.form || evt.target.getAttribute('id') !== this.dataset.form) return;
        const campos = [
          this.querySelector('[data-personalizacion-caja]'),
          this.letteringInput && this.letteringInput.required ? this.letteringInput : null,
        ];
        const vacio = campos.find((campo) => campo && !campo.value.trim());
        if (!vacio) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();
        vacio.value = '';
        vacio.setCustomValidity('Escribe el nombre para poder añadirla al carrito.');
        vacio.reportValidity();
        vacio.focus();
        vacio.addEventListener('input', () => vacio.setCustomValidity(''), { once: true });
      }

      select(mode, { silent } = {}) {
        const esSi = mode === 'si';

        this.btns.forEach((btn) => {
          const on = btn.dataset.personalizacion === mode;
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        if (this.letteringWrap) this.letteringWrap.hidden = !esSi;
        if (this.letteringInput) {
          this.letteringInput.required = esSi;
          if (esSi) {
            this.letteringInput.setAttribute('name', 'properties[Lettering]');
            this.letteringInput.setAttribute('form', this.dataset.form || '');
          } else {
            this.letteringInput.value = '';
            this.letteringInput.removeAttribute('name');
            this.letteringInput.removeAttribute('form');
          }
        }

        if (this.hiddenProp) {
          const selectedBtn = this.querySelector(`[data-personalizacion="${mode}"]`);
          this.hiddenProp.value = selectedBtn ? selectedBtn.textContent.trim() : mode;
        }

        if (this.optionInput) {
          this.optionInput.value = esSi
            ? this.optionValueFor('si')
            : this.optionValueFor('no');
        }

        const variantId = esSi ? this.variantSi : this.variantNo;
        if (variantId) this.setVariantId(variantId, silent);
      }

      optionValueFor(mode) {
        const optionName = this.dataset.optionName;
        if (!optionName) return '';
        const root = this.closest('.product__info-container') || document;
        const fieldset = [...root.querySelectorAll('.product-form__input')].find((el) => {
          const legend = el.querySelector('legend, .form__label');
          return legend && legend.textContent.toLowerCase().includes('personaliz');
        });
        if (!fieldset) {
          return mode === 'si' ? 'Personalizar' : 'No personalizar';
        }
        const inputs = fieldset.querySelectorAll('input[type="radio"]');
        for (const input of inputs) {
          const v = (input.value || '').toLowerCase();
          if (mode === 'no' && (v.includes('no personaliz') || v === 'no')) return input.value;
          if (mode === 'si' && v.includes('personaliz') && !v.includes('no personaliz')) return input.value;
        }
        return mode === 'si' ? 'Personalizar' : 'No personalizar';
      }

      setVariantId(id, silent) {
        const formId = this.dataset.form;
        const form = formId ? document.getElementById(formId) : null;
        const idInput = form?.querySelector('input[name="id"].product-variant-id') ||
          document.querySelector(`#${formId} input[name="id"], .product-variant-id`);
        if (!idInput) return;

        idInput.value = id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (silent) return;

        const sectionId = this.dataset.section;
        const variantSelects = document.getElementById(`variant-selects-${sectionId}`);
        if (variantSelects && typeof variantSelects.updateSelectionFromPersonalizacion === 'function') {
          variantSelects.updateSelectionFromPersonalizacion(id);
        } else {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          fetch(`${window.location.pathname}?variant=${id}&section_id=${sectionId}`)
            .then((r) => r.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const newPrice = doc.getElementById(`price-${sectionId}`);
              const curPrice = document.getElementById(`price-${sectionId}`);
              if (newPrice && curPrice) curPrice.innerHTML = newPrice.innerHTML;
            })
            .catch(() => {});
        }
      }
    }
  );
}
